import logo from './icons/logo.png'
import googleIcon from './icons/googleIcon.png'
import logout from './icons/logout.png'
import login from './icons/login.png'
import profile from './icons/profile.png'
import property from './icons/property.png'
import employee from './icons/employee.png'
import university from './icons/university.png'
import overview from './icons/overview.png'
import student from './icons/student.png'
import landlord from './icons/landlord.png'
import setting from './icons/setting.png'
import placeholder from './icons/profile-placeholder.jpg'
import wishlist from './icons/wishlist.png'
import header1 from './images/headerIMG1.jpg'
import header2 from './images/headerIMG2.jpg'
import about1 from './images/about1.jpg'
import about2 from './images/about2.jpg'
import about3 from './images/about3.jpg'
import abtBG from './images/aboutBg.jpg'
import agtBG from './images/agentBg.jpg'
import intro1 from './images/introIMG1.png'

import type1 from './images/type1.jpeg'
import type2 from './images/type2.jpg'
import type3 from './images/type3.jpg'
import type4 from './images/type4.jpg'
import type5 from './images/type5.jpg'
import type6 from './images/type6.jpg'

import poBG from './images/propertiesBg.jpg'
import poIMG from './images/propertyOwnerBg.png'
import mission from './images/missionIMG.jpg'
import team1 from './images/teamIMG1.jpg'
import team2 from './images/teamIMG2.jpg'
import team3 from './images/teamIMG3.jpg'
import team4 from './images/teamIMG4.jpg'
import step1 from './images/step1.jpg'
import step2 from './images/step2.jpg'
import step3 from './images/step3.jpg'
import property1 from './images/property1.jpg'
import property2 from './images/property2.jpg'
import property3 from './images/property3.jpg'
import property4 from './images/property4.jpg'
import defaultProperty from './images/fallBack.jpg'

import globe from './icons/globe.png'
import properties from './icons/properties.png'
import location from './icons/location.png'
import medal from './icons/medal.png'
import care from './icons/support.png'
import tag from './icons/tag.png'
import verified from './icons/verified.png'
import visa from './icons/visa.png'
import check from './icons/check.png'
import call from './icons/headerCall.png'
import building from './icons/headerHome.png'
import htag from './icons/headerTag.png'
import hSearch from './icons/houseSearch.png'
import cloud from './icons/management.png'
import house from './icons/house.png'
import stats from './icons/stats.png'
import comments from './icons/comments.png'
import visacard from './icons/visa-logo.png'
import paypal from './icons/paypal-logo.png'
import master from './icons/mastercard-logo.png'
import mtn from './icons/mtn-logo.jpg'
import airtel from './icons/airtel-logo.jpg'
import grid from './icons/grid.png'
import flutter from './icons/flutterLogo.png'
import quickBook from './icons/quickBook.png'
import values from './icons/lookupValues.png'
import verification from './icons/emailVerification.png'
import bed from './icons/bedrooms.png'
import bath from './icons/bathrooms.png'





export const asset = {
    logo,
    googleIcon,
    logout,
    login,
    profile,
    wishlist,
    care,
    tag,
    verified,
    visa,
    check,
    call,
    building,
    htag,
    hSearch,
    house,
    cloud,
    stats,
    visacard,
    master,
    paypal,
    mtn,
    airtel,
    grid,
    flutter,
    quickBook,
    verification,
    bed,
    bath,
    
}

export const drawer = {
    property,
    employee,
    university,
    overview,
    student,
    landlord,
    setting,
    placeholder,
    comments,
    values,
}

export const images = {
    header1,
    header2,
    about1,
    about2,
    about3,
    globe,
    properties,
    location,
    medal,
    intro1,
    team1,
    team2,
    team3,
    team4,
    mission,
    poIMG,
    step1,
    step2,
    step3,
    property1,
    property2,
    property3,
    property4,
    poBG,
    abtBG,
    agtBG,
    defaultProperty,
}

export const roomType = {
    type1,
    type2,
    type3,
    type4,
    type5,
    type6,
}
